import { Game, GameStatus, Query } from "@onmo/graphql/graphql";
import { gamesGQL } from "../graphql";
import { useQuery } from "@apollo/client/react/hooks/useQuery";
import { useMemo } from "react";
import { filter, uniq } from "lodash-es";
import { getGameImage } from "../models/game";
import { QueryOptions } from "@apollo/client";

export const useFetchGames = (options: Partial<QueryOptions> = {}) => {
  const { data } = useQuery<Query>(gamesGQL, {
    ...options,
    variables: {
      input: {
        status: GameStatus.Live,
        page: {
          limit: 250,
        },
      },
    },
  });

  const gamesCategory = useMemo(() => {
    if (!data?.games.items) return [];
    const filterGameByCategory = uniq(
      data?.games.items?.map((game: Game) => game.category),
    );
    const originArray = [
      ...uniq(filterGameByCategory.flatMap((item) => JSON.parse(item))),
    ];

    return originArray.filter((item) => item !== "Top 10");
  }, [data?.games.items]);

  const getGameImageById = (id?: string) => {
    const currentGame = data?.games.items.find((game: Game) => game.id === id);
    return getGameImage("small", currentGame);
  };

  const getListGameByCategory = (category: string) => {
    if (!data?.games.items) return [];
    return filter(data?.games.items, (game: Game) =>
      game.category.includes(category),
    );
  };

  return {
    listGames: data?.games.items,
    gamesCategory,
    getGameImageById,
    getListGameByCategory,
  };
};
